var Curriculog = Curriculog || {};

Curriculog.ManageApiSettings = (function ($, _, Backbone, ManageApiSettings, util, dom) {

    var ManageApiSettings = Curriculog.CurriculogView.extend({
            el: '#api-settings',
            template: 'Api/ApiSettingsManager.html',
            events: {
                'click #save-api-settings': 'save',
                'click #cancel-api-settings': 'render',
            },

            initialize: function (options) {
                this.collection = options.collection;
                this.enabledSetting = this.collection.enabledSetting();
                this.cui_enabled = options.cui_enabled;
                this.render();
            },

            render: function () {
                var templateVals = {enabledSetting: this.enabledSetting.toJSON()};
                var el = nunjucks.render(this.template, templateVals);
                this.replaceElement(el);
                if (!this.cui_enabled) {
                  objDom.verticalStretchList();
                }

            },

            save: function () {
                var enabledDropdownValue = $('#api-enabled').val()
                var view = this;

                if (enabledDropdownValue !== this.enabledSetting.get('value')) {
                    this.enabledSetting.save({
                        value: enabledDropdownValue,
                    }, {
                        error: function() {
                            var errorTitle = 'Error';
                            var errorText = 'An error was encountered when updating the API setting.  ';
                            errorText += 'Please try again or contact an administrator.';
                            view.showGrowl(errorTitle, errorText);
                        },

                        success: function (data) {
                            $('#growls').notify('create', 'saved-template', {
                                title: 'API Settings Saved',
                                text: 'The API settings have been successfully saved.'
                            });
                        },
                    })
                }
            },
    });

    return ManageApiSettings;

})($, _, Backbone, Curriculog.ManageApiSettings || {}, Curriculog.util, dom);
